import React, { useState } from 'react';
import "../styles/StaffApply.css"; // reuse same styles

const UnbanRequest = () => {
  const [formData, setFormData] = useState({
    name: '',
    discord: '',
    banReason: '',
    whyUnban: '',
  });
  const [successMsg, setSuccessMsg] = useState('');

  const handleChange = e => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const webhookURL = 'https://discord.com/api/webhooks/1375129023042027711/Tn9tTXjCb_R75US2AEoItl8Gx2bWk09qMtYxsYJvamHfL_8E9urX89zcgBjD827U7sxF';

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "🔓 New Unban Request",
          color: 16753920,  // orange-ish
          fields: [
            { name: "👤 Minecraft Username", value: formData.name },
            { name: "💬 Discord Tag", value: formData.discord },
            { name: "⛔ Ban Reason", value: formData.banReason || "Unknown" },
            { name: "🙏 Why Should You Be Unbanned?", value: formData.whyUnban },
          ],
          footer: { text: "RixxyMC Unban Request System" },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Unban request sent successfully!");
        setFormData({ name: '', discord: '', banReason: '', whyUnban: '' });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending unban request.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC Unban Request</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input id="name" type="text" value={formData.name} onChange={handleChange} required />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input id="discord" type="text" value={formData.discord} onChange={handleChange} required />

        <label htmlFor="banReason">Ban Reason (if known):</label>
        <input id="banReason" type="text" value={formData.banReason} onChange={handleChange} />

        <label htmlFor="whyUnban">Why should you be unbanned?</label>
        <textarea id="whyUnban" rows="4" value={formData.whyUnban} onChange={handleChange} required />

        <button type="submit">Submit Unban Request</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default UnbanRequest;
